define.alias("ember-composable-helpers/helpers/map-by", "calendar/helpers/map-by");